import type { CsvTerrificField } from '@entities/platform-entities/integration/csv-terrific-field.type';

export const CSV_TERRIFIC_FIELD_LABELS: Record<CsvTerrificField, string> = {
  availability: 'Availability',
  color: 'Color',
  description: 'Description',
  externalId: 'External ID',
  externalUrl: 'External URL',
  imageUrl: 'Image URL',
  price: 'Price',
  salePrice: 'Sale price',
  size: 'Size',
  sku: 'SKU',
  title: 'Title',
};
